import { WanIcon } from './WanIcon';

/**
 * author: Simran
 * id 0E468855-81AF-4CA1-ACF0-D166D07F188C
 * name wan
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wan.svg
 * tags
 */
export const WideAreaNetworkIcon = WanIcon;
export default WideAreaNetworkIcon